<div *ngIf="showAction">
    <ng-select
        class="ng-select-company"
        [items]="companies"
        bindLabel="Name"
        [(ngModel)]="companySelected"
        (change)="onChangeCompany()"
    >
    </ng-select>
</div>
